var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-instance-page" },
    [
      _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
        _c("div", { staticClass: "nk-block-between align-items-start" }, [
          _c(
            "div",
            { staticClass: "nk-block-head-content admin-instance-list__intro" },
            [
              _c("div", { staticClass: "admin-instance-list__title-row" }, [
                _c("h3", { staticClass: "nk-block-title page-title mb-0" }, [
                  _vm._v(_vm._s(_vm.trans("instance.instance"))),
                ]),
              ]),
              _vm._v(" "),
              !_vm.instances.total
                ? _c("div", { staticClass: "nk-block-des text-soft" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.trans("instance.module_info_description"))
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "nk-fmg-actions flex-shrink-0" }, [
            _c(
              "ul",
              {
                staticClass: "nk-block-tools g-2 flex-wrap justify-content-end",
              },
              [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                      attrs: {
                        href: "#",
                        role: "button",
                        "aria-controls": "instance-filter-panel",
                        "aria-expanded": _vm.showFilterPanel ? "true" : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.showFilterPanel = !_vm.showFilterPanel
                        },
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          )
                            return null
                          $event.preventDefault()
                          _vm.showFilterPanel = !_vm.showFilterPanel
                        },
                      },
                    },
                    [
                      _c("admin-icon", {
                        attrs: { name: "sliders", "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.trans("general.filter")))]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.hasPermission("edit-instance")
                  ? _c("li", { staticClass: "nk-block-tools-opt" }, [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.modal-instance-create",
                              modifiers: { "modal-instance-create": true },
                            },
                          ],
                          staticClass:
                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                          attrs: { type: "button" },
                        },
                        [
                          _c("admin-icon", { attrs: { name: "plus" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.trans("instance.add_new_instance")) +
                              "\n                        "
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showFilterPanel
          ? _c(
              "div",
              {
                staticClass: "card admin-instance-form-card mb-2",
                attrs: { id: "instance-filter-panel" },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "admin-instance-card-head" }, [
                    _c(
                      "h4",
                      { staticClass: "admin-instance-card-head__title" },
                      [_vm._v(_vm._s(_vm.trans("general.filter")))]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "admin-instance-card-head__hint" }, [
                      _vm._v(_vm._s(_vm.trans("instance.instance"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-sm-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("instance.domain"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterInstanceForm.domain,
                              expression: "filterInstanceForm.domain",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "domain" },
                          domProps: { value: _vm.filterInstanceForm.domain },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.filterInstanceForm,
                                "domain",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("instance.custom_domain"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterInstanceForm.custom_domain,
                              expression: "filterInstanceForm.custom_domain",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "custom_domain" },
                          domProps: {
                            value: _vm.filterInstanceForm.custom_domain,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.filterInstanceForm,
                                "custom_domain",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("instance.email"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterInstanceForm.email,
                              expression: "filterInstanceForm.email",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { name: "email" },
                          domProps: { value: _vm.filterInstanceForm.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.filterInstanceForm,
                                "email",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("instance.status"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filterInstanceForm.status,
                                expression: "filterInstanceForm.status",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "status" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filterInstanceForm,
                                  "status",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.trans("general.select_one"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "pending" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.pending"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "running" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.running"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "trial" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.trial"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "expired" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.expired"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "suspended" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.suspended"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "terminated" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.terminated"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("date-range-picker", {
                            attrs: {
                              "start-date": _vm.filterInstanceForm.start_date,
                              "end-date": _vm.filterInstanceForm.end_date,
                              label: _vm.trans("general.date_between"),
                            },
                            on: {
                              "update:startDate": function ($event) {
                                return _vm.$set(
                                  _vm.filterInstanceForm,
                                  "start_date",
                                  $event
                                )
                              },
                              "update:start-date": function ($event) {
                                return _vm.$set(
                                  _vm.filterInstanceForm,
                                  "start_date",
                                  $event
                                )
                              },
                              "update:endDate": function ($event) {
                                return _vm.$set(
                                  _vm.filterInstanceForm,
                                  "end_date",
                                  $event
                                )
                              },
                              "update:end-date": function ($event) {
                                return _vm.$set(
                                  _vm.filterInstanceForm,
                                  "end_date",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("general.sort_by"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filterInstanceForm.sort_by,
                                expression: "filterInstanceForm.sort_by",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "order" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filterInstanceForm,
                                  "sort_by",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "first_name" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.instanceTxt("instance.client", "Client")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "email" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.email"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "created_at" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.created_at"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "status" } }, [
                              _vm._v(_vm._s(_vm.trans("instance.status"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(_vm._s(_vm.trans("general.order"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filterInstanceForm.order,
                                expression: "filterInstanceForm.order",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "order" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filterInstanceForm,
                                  "order",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "asc" } }, [
                              _vm._v(_vm._s(_vm.trans("general.ascending"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "desc" } }, [
                              _vm._v(_vm._s(_vm.trans("general.descending"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.hasPermission("list-instance") && _vm.instances.total
        ? _c("div", { staticClass: "admin-list-table-card mt-2" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table admin-data-table admin-data-table--config-list admin-data-table--instance-list mb-0",
                },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      [
                        _c(
                          "sortable-th",
                          {
                            attrs: {
                              field: "first_name",
                              "sort-by": _vm.filterInstanceForm.sort_by,
                              order: _vm.filterInstanceForm.order,
                            },
                            on: { sort: _vm.sortList },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.instanceTxt("instance.client", "Client")
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sortable-th",
                          {
                            attrs: {
                              field: "status",
                              "sort-by": _vm.filterInstanceForm.sort_by,
                              order: _vm.filterInstanceForm.order,
                            },
                            on: { sort: _vm.sortList },
                          },
                          [_vm._v(_vm._s(_vm.trans("instance.status")))]
                        ),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.trans("plan.plan")))]),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "admin-table-cell--instance-db" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.instanceTxt("instance.database", "Database")
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sortable-th",
                          {
                            attrs: {
                              field: "created_at",
                              "sort-by": _vm.filterInstanceForm.sort_by,
                              order: _vm.filterInstanceForm.order,
                            },
                            on: { sort: _vm.sortList },
                          },
                          [_vm._v(_vm._s(_vm.trans("instance.created_at")))]
                        ),
                        _vm._v(" "),
                        _c("th", { staticClass: "admin-table-actions-cell" }, [
                          _vm._v(_vm._s(_vm.trans("general.actions"))),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.instances.data, function (instance) {
                      return _c("tr", { key: instance.id }, [
                        _c(
                          "td",
                          { staticClass: "admin-table-cell--instance-client" },
                          [
                            _c(
                              "div",
                              { staticClass: "admin-instance-client" },
                              [
                                _vm.instanceClientPrimary(instance)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "admin-instance-stack__primary",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.instanceClientPrimary(instance)
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.instanceClientSchoolLine(instance)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "admin-instance-stack__school",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.instanceClientSchoolLine(
                                              instance
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                instance.email &&
                                _vm.instanceClientPrimary(instance) !==
                                  instance.email
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "admin-instance-stack__muted",
                                      },
                                      [_vm._v(_vm._s(instance.email))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                instance.status == "pending" &&
                                instance.activation_token
                                  ? _c("p", { staticClass: "mb-0" }, [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(instance.activation_token)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                instance.phone
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "admin-instance-stack__muted",
                                      },
                                      [_vm._v(_vm._s(instance.phone))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.instanceSchoolPortalUrl(instance)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "admin-instance-stack__domain",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "admin-instance-domain-row",
                                          },
                                          [
                                            _vm.canInstanceDirectLogin(instance)
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "admin-instance-domain-link",
                                                    attrs: {
                                                      href: "#",
                                                      title: _vm.trans(
                                                        "instance.direct_login_school"
                                                      ),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.openSchoolDirectLogin(
                                                          instance
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.instanceDomainDisplayLabel(
                                                          instance
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "admin-instance-domain-link",
                                                    attrs: {
                                                      href: _vm.instanceSchoolPortalUrl(
                                                        instance
                                                      ),
                                                      target: "_blank",
                                                      rel: "noopener",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.instanceDomainDisplayLabel(
                                                          instance
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-icon btn-sm admin-instance-domain-copy",
                                                attrs: {
                                                  type: "button",
                                                  title: _vm.trans(
                                                    "instance.copy_school_url"
                                                  ),
                                                  "aria-label": _vm.trans(
                                                    "instance.copy_school_url"
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.copySchoolPortalUrl(
                                                      instance
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("admin-icon", {
                                                  attrs: {
                                                    name: "copy",
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.instanceCustomDomainLabel(instance)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "admin-instance-stack__muted",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.instanceCustomDomainLabel(
                                              instance
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(
                            _vm.getInstanceStatus(instance),
                            function (st, idx) {
                              return _c(
                                "span",
                                {
                                  key: idx,
                                  class: [
                                    "admin-status-badge",
                                    "admin-status-badge--" + st.color,
                                    idx ? "admin-status-badge--stack" : "",
                                  ],
                                },
                                [
                                  st.icon
                                    ? _c("admin-icon", {
                                        attrs: {
                                          name: st.icon,
                                          "aria-hidden": "true",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(st.label) +
                                      "\n                            "
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "admin-instance-stack" }, [
                            _c(
                              "div",
                              { staticClass: "admin-instance-stack__primary" },
                              [
                                _vm._v(
                                  _vm._s(instance.plan && instance.plan.name)
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            instance.currency || instance.frequency
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "admin-instance-stack__muted",
                                  },
                                  [
                                    instance.currency
                                      ? [_vm._v(_vm._s(instance.currency.name))]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    instance.currency && instance.frequency
                                      ? [_vm._v(" · ")]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    instance.frequency
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.trans(
                                                "list." + instance.frequency
                                              )
                                            )
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "admin-table-cell--instance-db" },
                          [
                            _c("div", { staticClass: "admin-instance-stack" }, [
                              _vm.instanceDatabaseName(instance)
                                ? _c(
                                    "code",
                                    {
                                      staticClass: "admin-instance-stack__mono",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.instanceDatabaseName(instance)
                                        )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "admin-instance-stack__muted",
                                    },
                                    [_vm._v("—")]
                                  ),
                              _vm._v(" "),
                              _vm.instanceDatabaseId(instance)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "admin-instance-stack__muted",
                                    },
                                    [
                                      _vm._v(
                                        "#" +
                                          _vm._s(
                                            _vm.instanceDatabaseId(instance)
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm._f("moment")(instance.created_at))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "admin-table-actions-cell" },
                          [
                            _c(
                              "table-row-action-dropdown",
                              [
                                _vm.hasPermission("list-instance")
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: "/instance/" + instance.id,
                                        },
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: { name: "eye" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.trans(
                                                "instance.view_instance"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasPermission("list-instance") &&
                                (instance.status === "running" ||
                                  instance.status === "trial")
                                  ? _c(
                                      "b-dropdown-item-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.openSchoolDirectLogin(
                                              instance
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: { name: "external-link" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.trans(
                                                "instance.direct_login_school"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasPermission("delete-instance")
                                  ? _c(
                                      "b-dropdown-item-button",
                                      {
                                        directives: [
                                          {
                                            name: "confirm",
                                            rawName: "v-confirm",
                                            value: {
                                              ok: _vm.confirmDelete(instance),
                                            },
                                            expression:
                                              "{ok: confirmDelete(instance)}",
                                          },
                                        ],
                                        staticClass:
                                          "admin-row-actions__danger",
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: { name: "trash" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.trans("general.delete")
                                            ) +
                                            "\n                                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "admin-table-pagination-wrap" },
              [
                _c("pagination-record", {
                  attrs: {
                    "page-length": _vm.filterInstanceForm.page_length,
                    records: _vm.instances,
                  },
                  on: {
                    "update:pageLength": function ($event) {
                      return _vm.$set(
                        _vm.filterInstanceForm,
                        "page_length",
                        $event
                      )
                    },
                    "update:page-length": function ($event) {
                      return _vm.$set(
                        _vm.filterInstanceForm,
                        "page_length",
                        $event
                      )
                    },
                    updateRecords: _vm.getInstances,
                  },
                  nativeOn: {
                    change: function ($event) {
                      return _vm.getInstances.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.instances.total
        ? _c(
            "div",
            {
              staticClass: "admin-list-table-card admin-empty-state mt-3",
              attrs: { role: "status" },
            },
            [
              _c("div", { staticClass: "admin-empty-state__inner" }, [
                _c(
                  "div",
                  {
                    staticClass: "admin-empty-state__icon-wrap",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_c("admin-icon", { attrs: { name: "database" } })],
                  1
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "admin-empty-state__title" }, [
                  _vm._v(_vm._s(_vm.trans("instance.empty_list_title"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "admin-empty-state__text" }, [
                  _vm._v(_vm._s(_vm.trans("instance.empty_list_hint"))),
                ]),
                _vm._v(" "),
                _vm.hasPermission("edit-instance")
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.modal-instance-create",
                            modifiers: { "modal-instance-create": true },
                          },
                        ],
                        staticClass:
                          "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid mt-2",
                        attrs: { type: "button" },
                      },
                      [
                        _c("admin-icon", { attrs: { name: "plus" } }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.trans("instance.add_new_instance")) +
                            "\n            "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-instance-create",
            "hide-footer": "",
            "hide-header": "",
            size: "lg",
            centered: "",
            "modal-class": "admin-modal-pro admin-modal-pro--instance-create",
            "content-class":
              "admin-modal-pro__content admin-modal-pro__content--instance-create",
            "body-class": "p-0",
          },
          on: { shown: _vm.resetInstanceCreateWizard },
        },
        [
          _c("div", { staticClass: "admin-instance-create-card" }, [
            _c(
              "button",
              {
                staticClass: "admin-instance-create-card__close close",
                attrs: {
                  type: "button",
                  "aria-label": _vm.trans("general.close"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$bvModal.hide("modal-instance-create")
                  },
                },
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
            _vm._v(" "),
            _c("h2", { staticClass: "admin-instance-create-card__title" }, [
              _vm._v(_vm._s(_vm.trans("instance.add_new_instance"))),
            ]),
            _vm._v(" "),
            _vm.instanceCreateStep === 1
              ? _c("p", { staticClass: "admin-instance-create-card__sub" }, [
                  _vm._v(
                    _vm._s(_vm.trans("instance.create_modal_subdomain_step"))
                  ),
                ])
              : _c("p", { staticClass: "admin-instance-create-card__sub" }, [
                  _vm._v(
                    _vm._s(_vm.trans("instance.create_modal_details_step"))
                  ),
                ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "admin-instance-create-form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submitNewInstance.apply(null, arguments)
                  },
                  keydown: function ($event) {
                    return _vm.instanceForm.errors.clear($event.target.name)
                  },
                },
              },
              [
                _vm.instanceCreateStep === 1
                  ? [
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-domain" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("instance.school_subdomain")) +
                                  " "
                              ),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "admin-instance-create-domain-input",
                              class: _vm.instanceCreateDomainInputClass,
                              attrs: { id: "instance-create-domain-wrap" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.domainDraft,
                                    expression: "domainDraft",
                                  },
                                ],
                                staticClass:
                                  "admin-instance-create-domain-input__field",
                                attrs: {
                                  id: "instance-create-domain",
                                  type: "text",
                                  autocomplete: "off",
                                  placeholder: _vm.trans("instance.domain"),
                                },
                                domProps: { value: _vm.domainDraft },
                                on: {
                                  blur: _vm.onDomainInputBlur,
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.domainDraft = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass:
                                  "admin-instance-create-domain-input__suffix",
                                domProps: {
                                  textContent: _vm._s(_vm.domainSuffix),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.domainLiveCheck.loading &&
                          _vm.normalizedDomainDraft
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "admin-domain-live-status admin-domain-live-status--pending",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "admin-domain-live-status__pulse",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "admin-domain-live-status__text",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.instanceTxt(
                                            "instance.domain_checking",
                                            "Checking availability…"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm.normalizedDomainDraft &&
                              _vm.domainResultVariant !== "none"
                            ? _c(
                                "div",
                                { staticClass: "admin-domain-result-wrap" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "admin-domain-result-banner",
                                      class:
                                        "admin-domain-result-banner--" +
                                        _vm.domainResultVariant,
                                      attrs: { role: "status" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "admin-domain-result-banner__headline",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.domainResultHeadline)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.domainResultDetail
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "admin-domain-result-banner__detail",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.domainResultDetail)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.domainResultVariant === "ok"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "admin-domain-preview",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    https://" +
                                                  _vm._s(
                                                    _vm.domainLiveCheck.slug
                                                  )
                                              ),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.normalizedListDomainSuffix()
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.domainResultVariant === "invalid" ||
                                        _vm.domainResultVariant === "error") &&
                                      _vm.domainLiveCheck.validation_errors &&
                                      _vm.domainLiveCheck.validation_errors
                                        .length
                                        ? _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "admin-domain-live-errors",
                                            },
                                            _vm._l(
                                              _vm.domainLiveCheck
                                                .validation_errors,
                                              function (err, ei) {
                                                return _c("li", { key: ei }, [
                                                  _vm._v(_vm._s(err)),
                                                ])
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.domainResultVariant === "taken" &&
                                      _vm.domainLiveCheck.suggestions &&
                                      _vm.domainLiveCheck.suggestions.length
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "admin-domain-suggestions",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "admin-domain-suggestions__label",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.instanceTxt(
                                                        "instance.domain_try_suggestions",
                                                        "Try one of these (click to use):"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "admin-domain-suggestions__chips",
                                                },
                                                _vm._l(
                                                  _vm.domainLiveCheck
                                                    .suggestions,
                                                  function (sug) {
                                                    return _c(
                                                      "button",
                                                      {
                                                        key: sug,
                                                        staticClass:
                                                          "admin-domain-suggestion-chip",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.applyDomainSuggestion(
                                                              sug
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(sug))]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.instanceCreateStep === 1 &&
                          _vm.normalizedDomainDraft &&
                          !_vm.canContinueInstanceDomainStep
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "admin-domain-step1-actions mt-2",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "admin-domain-continue-hint text-soft small mb-0",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.instanceTxt(
                                              "instance.domain_continue_hint",
                                              "Confirm an available address to continue to the next step."
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.domainLiveCheck.loading
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-sm btn-outline-primary mt-2",
                                          attrs: { type: "button" },
                                          on: { click: _vm.runDomainCheck },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.instanceTxt(
                                                  "instance.domain_check_button",
                                                  "Check availability"
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.canContinueInstanceDomainStep,
                              expression: "canContinueInstanceDomainStep",
                            },
                          ],
                          staticClass: "admin-instance-create-submit",
                          attrs: { type: "button" },
                          on: { click: _vm.goToInstanceCreateStep2 },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.instanceTxt(
                                  "instance.domain_continue",
                                  "Continue"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("admin-icon", {
                            attrs: {
                              name: "arrow-right",
                              "aria-hidden": "true",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.instanceCreateStep === 2,
                        expression: "instanceCreateStep === 2",
                      },
                    ],
                    staticClass: "admin-instance-create-locked-domain",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "admin-instance-create-locked-domain__text",
                      },
                      [
                        _c("admin-icon", {
                          attrs: { name: "link", "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.instanceForm.domain)),
                          ]),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.normalizedListDomainSuffix()
                              ),
                            },
                          }),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm btn-outline-secondary admin-instance-create-locked-domain__edit",
                        attrs: { type: "button" },
                        on: { click: _vm.backToInstanceCreateDomainStep },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.trans("instance.domain_change_subdomain")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.instanceCreateStep === 2,
                        expression: "instanceCreateStep === 2",
                      },
                    ],
                    staticClass: "admin-instance-create-grid-2",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "admin-instance-create-field" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "admin-instance-create-label",
                            attrs: { for: "instance-create-fn" },
                          },
                          [
                            _vm._v(_vm._s(_vm.trans("user.first_name")) + " "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.instanceForm.first_name,
                              expression: "instanceForm.first_name",
                            },
                          ],
                          staticClass:
                            "form-control admin-instance-create-control",
                          attrs: {
                            id: "instance-create-fn",
                            type: "text",
                            name: "first_name",
                            placeholder: _vm.trans("user.first_name"),
                          },
                          domProps: { value: _vm.instanceForm.first_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.instanceForm,
                                "first_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.instanceForm,
                            "prop-name": "first_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "admin-instance-create-field" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "admin-instance-create-label",
                            attrs: { for: "instance-create-ln" },
                          },
                          [
                            _vm._v(_vm._s(_vm.trans("user.last_name")) + " "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.instanceForm.last_name,
                              expression: "instanceForm.last_name",
                            },
                          ],
                          staticClass:
                            "form-control admin-instance-create-control",
                          attrs: {
                            id: "instance-create-ln",
                            type: "text",
                            name: "last_name",
                            placeholder: _vm.trans("user.last_name"),
                          },
                          domProps: { value: _vm.instanceForm.last_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.instanceForm,
                                "last_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.instanceForm,
                            "prop-name": "last_name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.instanceCreateStep === 2,
                        expression: "instanceCreateStep === 2",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "admin-instance-create-field" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "admin-instance-create-label",
                            attrs: { for: "instance-create-school" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.trans("instance.school_name")) + " "
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.instanceForm.school_name,
                              expression: "instanceForm.school_name",
                            },
                          ],
                          staticClass:
                            "form-control admin-instance-create-control",
                          attrs: {
                            id: "instance-create-school",
                            type: "text",
                            name: "school_name",
                            placeholder: _vm.trans("instance.school_name"),
                          },
                          domProps: { value: _vm.instanceForm.school_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.instanceForm,
                                "school_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.instanceForm,
                            "prop-name": "school_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "admin-instance-create-field" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "admin-instance-create-label",
                            attrs: { for: "instance-create-email" },
                          },
                          [
                            _vm._v(_vm._s(_vm.trans("instance.email")) + " "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.instanceForm.email,
                              expression: "instanceForm.email",
                            },
                          ],
                          staticClass:
                            "form-control admin-instance-create-control",
                          attrs: {
                            id: "instance-create-email",
                            type: "email",
                            name: "email",
                            placeholder: _vm.trans("instance.email"),
                          },
                          domProps: { value: _vm.instanceForm.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.instanceForm,
                                "email",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.instanceForm,
                            "prop-name": "email",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-instance-create-grid-2" }, [
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-user" },
                            },
                            [_vm._v(_vm._s(_vm.trans("instance.username")))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.instanceForm.username,
                                expression: "instanceForm.username",
                              },
                            ],
                            staticClass:
                              "form-control admin-instance-create-control",
                            attrs: {
                              id: "instance-create-user",
                              type: "text",
                              name: "username",
                              placeholder: _vm.trans("instance.username"),
                            },
                            domProps: { value: _vm.instanceForm.username },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.instanceForm,
                                  "username",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "username",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-tz" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.timezone"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.instanceForm.timezone,
                                  expression: "instanceForm.timezone",
                                },
                              ],
                              staticClass:
                                "form-control admin-instance-create-control",
                              attrs: {
                                id: "instance-create-tz",
                                name: "timezone",
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.instanceForm,
                                    "timezone",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one"))),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.createTimezones, function (tz) {
                                return _c(
                                  "option",
                                  {
                                    key: tz.value,
                                    domProps: { value: tz.value },
                                  },
                                  [_vm._v(_vm._s(tz.text))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "timezone",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-instance-create-grid-2" }, [
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-pw" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("instance.admin_password")) +
                                  " "
                              ),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.instanceForm.password,
                                expression: "instanceForm.password",
                              },
                            ],
                            staticClass:
                              "form-control admin-instance-create-control",
                            attrs: {
                              id: "instance-create-pw",
                              type: "password",
                              name: "password",
                              placeholder: _vm.trans("user.password"),
                              autocomplete: "new-password",
                            },
                            domProps: { value: _vm.instanceForm.password },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.instanceForm,
                                  "password",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "password",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-pw2" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("user.password_confirmation")
                                ) + " "
                              ),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.instanceForm.password_confirmation,
                                expression:
                                  "instanceForm.password_confirmation",
                              },
                            ],
                            staticClass:
                              "form-control admin-instance-create-control",
                            attrs: {
                              id: "instance-create-pw2",
                              type: "password",
                              name: "password_confirmation",
                              placeholder: _vm.trans(
                                "user.password_confirmation"
                              ),
                              autocomplete: "new-password",
                            },
                            domProps: {
                              value: _vm.instanceForm.password_confirmation,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.instanceForm,
                                  "password_confirmation",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "password_confirmation",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-instance-create-grid-2" }, [
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-phone" },
                            },
                            [
                              _vm._v(_vm._s(_vm.trans("instance.phone")) + " "),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.instanceForm.phone,
                                expression: "instanceForm.phone",
                              },
                            ],
                            staticClass:
                              "form-control admin-instance-create-control",
                            attrs: {
                              id: "instance-create-phone",
                              type: "text",
                              name: "phone",
                              placeholder: _vm.trans("instance.phone"),
                            },
                            domProps: { value: _vm.instanceForm.phone },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.instanceForm,
                                  "phone",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "phone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-country" },
                            },
                            [
                              _vm._v(_vm._s(_vm.trans("user.country")) + " "),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.instanceForm.country_id,
                                  expression: "instanceForm.country_id",
                                },
                              ],
                              staticClass:
                                "form-control admin-instance-create-control",
                              attrs: {
                                id: "instance-create-country",
                                name: "country_id",
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.instanceForm,
                                    "country_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one"))),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.createCountries, function (c) {
                                return _c(
                                  "option",
                                  {
                                    key: c.value,
                                    domProps: { value: c.value },
                                  },
                                  [_vm._v(_vm._s(c.text))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "country_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-instance-create-grid-2" }, [
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-plan" },
                            },
                            [
                              _vm._v(_vm._s(_vm.trans("plan.plan")) + " "),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.instanceForm.plan_id,
                                  expression: "instanceForm.plan_id",
                                },
                              ],
                              staticClass:
                                "form-control admin-instance-create-control",
                              attrs: {
                                id: "instance-create-plan",
                                name: "plan_id",
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.instanceForm,
                                    "plan_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one"))),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.createPlans, function (plan) {
                                return _c(
                                  "option",
                                  {
                                    key: plan.id,
                                    domProps: { value: plan.id },
                                  },
                                  [_vm._v(_vm._s(plan.name))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "plan_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-currency" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("currency.currency")) + " "
                              ),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.instanceForm.currency_id,
                                  expression: "instanceForm.currency_id",
                                },
                              ],
                              staticClass:
                                "form-control admin-instance-create-control",
                              attrs: {
                                id: "instance-create-currency",
                                name: "currency_id",
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.instanceForm,
                                    "currency_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one"))),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.createCurrencies, function (cur) {
                                return _c(
                                  "option",
                                  { key: cur.id, domProps: { value: cur.id } },
                                  [_vm._v(_vm._s(cur.name))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "currency_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-instance-create-grid-2" }, [
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-freq" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.trans("plan.payment_frequency")) +
                                  " "
                              ),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.instanceForm.frequency,
                                  expression: "instanceForm.frequency",
                                },
                              ],
                              staticClass:
                                "form-control admin-instance-create-control",
                              attrs: {
                                id: "instance-create-freq",
                                name: "frequency",
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.instanceForm,
                                    "frequency",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one"))),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.createFrequencies, function (fr) {
                                return _c(
                                  "option",
                                  { key: fr.id, domProps: { value: fr.id } },
                                  [_vm._v(_vm._s(fr.name))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "frequency",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-max" },
                            },
                            [_vm._v(_vm._s(_vm.trans("instance.max_student")))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.instanceForm.max_student,
                                expression: "instanceForm.max_student",
                              },
                            ],
                            staticClass:
                              "form-control admin-instance-create-control",
                            attrs: {
                              id: "instance-create-max",
                              type: "number",
                              name: "max_student",
                              min: "1",
                              placeholder: _vm.trans("instance.max_student"),
                            },
                            domProps: { value: _vm.instanceForm.max_student },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.instanceForm,
                                  "max_student",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "max_student",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "admin-instance-create-field" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "admin-instance-create-label",
                            attrs: { for: "instance-create-a1" },
                          },
                          [_vm._v(_vm._s(_vm.trans("user.address_line_1")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.instanceForm.address_line_1,
                              expression: "instanceForm.address_line_1",
                            },
                          ],
                          staticClass:
                            "form-control admin-instance-create-control",
                          attrs: {
                            id: "instance-create-a1",
                            type: "text",
                            name: "address_line_1",
                            placeholder: _vm.trans("user.address_line_1"),
                          },
                          domProps: { value: _vm.instanceForm.address_line_1 },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.instanceForm,
                                "address_line_1",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.instanceForm,
                            "prop-name": "address_line_1",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "admin-instance-create-field" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "admin-instance-create-label",
                            attrs: { for: "instance-create-a2" },
                          },
                          [_vm._v(_vm._s(_vm.trans("user.address_line_2")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.instanceForm.address_line_2,
                              expression: "instanceForm.address_line_2",
                            },
                          ],
                          staticClass:
                            "form-control admin-instance-create-control",
                          attrs: {
                            id: "instance-create-a2",
                            type: "text",
                            name: "address_line_2",
                            placeholder: _vm.trans("user.address_line_2"),
                          },
                          domProps: { value: _vm.instanceForm.address_line_2 },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.instanceForm,
                                "address_line_2",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.instanceForm,
                            "prop-name": "address_line_2",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-instance-create-grid-2" }, [
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-city" },
                            },
                            [_vm._v(_vm._s(_vm.trans("user.city")))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.instanceForm.city,
                                expression: "instanceForm.city",
                              },
                            ],
                            staticClass:
                              "form-control admin-instance-create-control",
                            attrs: {
                              id: "instance-create-city",
                              type: "text",
                              name: "city",
                              placeholder: _vm.trans("user.city"),
                            },
                            domProps: { value: _vm.instanceForm.city },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.instanceForm,
                                  "city",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "city",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "admin-instance-create-field" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "admin-instance-create-label",
                              attrs: { for: "instance-create-state" },
                            },
                            [_vm._v(_vm._s(_vm.trans("user.state")))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.instanceForm.state,
                                expression: "instanceForm.state",
                              },
                            ],
                            staticClass:
                              "form-control admin-instance-create-control",
                            attrs: {
                              id: "instance-create-state",
                              type: "text",
                              name: "state",
                              placeholder: _vm.trans("user.state"),
                            },
                            domProps: { value: _vm.instanceForm.state },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.instanceForm,
                                  "state",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.instanceForm,
                              "prop-name": "state",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "admin-instance-create-field" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "admin-instance-create-label",
                            attrs: { for: "instance-create-zip" },
                          },
                          [_vm._v(_vm._s(_vm.trans("user.zipcode")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.instanceForm.zipcode,
                              expression: "instanceForm.zipcode",
                            },
                          ],
                          staticClass:
                            "form-control admin-instance-create-control",
                          attrs: {
                            id: "instance-create-zip",
                            type: "text",
                            name: "zipcode",
                            placeholder: _vm.trans("user.zipcode"),
                          },
                          domProps: { value: _vm.instanceForm.zipcode },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.instanceForm,
                                "zipcode",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.instanceForm,
                            "prop-name": "zipcode",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.instanceCreateStep === 2,
                        expression: "instanceCreateStep === 2",
                      },
                    ],
                    staticClass: "admin-instance-create-submit",
                    attrs: { type: "submit" },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.trans("general.add")))]),
                    _vm._v(" "),
                    _c("admin-icon", {
                      attrs: { name: "arrow-right", "aria-hidden": "true" },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }